import React from 'react';

import storage from 'local-storage';

import { connectI18n } from '../../../connects';
import ButtonLink from '../../../elements/ButtonLink';
import PleaseWait from '../../PleaseWait';
import Screen from '../../Screen';
import Scrollable from '../../../elements/Scrollable';
import TopBar from '../../../elements/TopBar/TopBar';

class ConfirmDeleteEventScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
            busy: false,
        };
    }
    componentDidMount() {
        this.state.mounted = true;
    }
    componentWillUnmount() {
        this.state.mounted = false;
    }
    render() {
        if (this.state.busy) {
            return <PleaseWait />;
        }

        let { i18n } = this.props,
            header = (
                <div>
                    <TopBar returnURL=".." />
                    <hr />
                    <div className="content bgwhite text">{i18n['label.delete.newtwork.data']}</div>
                </div>
            ),
            footer = (
                <div className="content">
                    <table className="layout">
                        <tbody>
                            <tr>
                                <td
                                    style={{
                                        paddingRight: '1em',
                                    }}>
                                    <ButtonLink
                                        href=".."
                                        style={{
                                            border: 0,
                                            fontSize: '150%',
                                            backgroundColor: 'white',
                                        }}>
                                        {i18n['label.cancel']}
                                    </ButtonLink>
                                </td>
                                <td>
                                    <ButtonLink
                                        onClick={this.handleConfirmDelete.bind(this)}
                                        style={{
                                            border: 0,
                                            backgroundColor: 'red',
                                            color: 'white',
                                            fontSize: '150%',
                                        }}>
                                        {i18n['button.yes-permanently']}
                                    </ButtonLink>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );

        return (
            <Screen header={header} footer={footer}>
                <Scrollable>
                    <div className="content text">
                        <div
                            style={{
                                fontSize: '130%',
                            }}>
                            <br />
                            <h4>{i18n['label.deleteprofile.heading']}</h4>
                            <br />
                            <p>{i18n['label.paragraphnetwork1']}</p>
                            <p>{i18n['label.paragraphnetwork2']}</p>
                        </div>
                    </div>
                </Scrollable>
            </Screen>
        );
    }
    handleConfirmDelete() {
        this.setState({ busy: true });

        app.history.push('/');
        app.api.users
            .deleteAccount()
            .then(() => {
                storage.clear();
            })
            .catch(console.error)
            .then(() => {
                if (this.state.mounted) {
                    this.setState({ busy: false });
                }
            });
    }
}

export default connectI18n(ConfirmDeleteEventScreen);
